<template>
    <a-select :mode="multiple ? 'multiple' : undefined" v-model:value="valueState" placeholder="Pilih Sales" allow-clear
        show-search show-arrow :not-found-content="state.loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label" option-label-prop="label" @search="onSearch"
        @dropdownVisibleChange="dropdownVisibleChange" :loading="state.loading" v-bind="$attrs" style="width:300px">
        <a-select-option v-for="d in state.data" :key="d.id" :value="d.id" :label="d.nopeg + ' - ' + d.fullname">
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="highlight(d.nopeg + ' - ' + d.fullname)"></span>
            <!--eslint-enable-->
        </a-select-option>
        <template v-if="state.loading" #notFoundContent>
            <a-spin size="small" />
        </template>
    </a-select>
</template>

<script>
import { watch, reactive } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, pickBy } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        role_id: {
            type: [Array, Number, String],
            default: () => [],
        },
        wilayah_id: {
            type: [Array, Number, String],
            default: () => [],
        },
        parent_id: {
            type: [Array, Number, String],
            default: () => [],
        },
        multiple: {
            type: Boolean,
            default: true,
        },
    },

    emits: ['update:value'],

    setup(props, { emit }) {
        const state = reactive({
            endpoint: '/api/filter/sales',
            loading: false,
            data: [],
            params: {
                q: '',
                role_id: props.role_id,
                parent_id: props.parent_id,
                wilayah_id: props.wilayah_id,
            },
        })

        const hasValue = value => {
            if (Array.isArray(value)) {
                return value.length > 0
            }

            return (
                value !== null &&
                value !== undefined &&
                value !== ''
            )
        }

        const fetchData = async () => {
            if (
                !props.multiple &&
                (
                    !hasValue(props.role_id) ||
                    !hasValue(props.wilayah_id)
                )
            ) {
                state.data = []
                return
            }

            const params = pickBy({
                q: state.params.q,
                role_id: props.role_id,
                parent_id: props.parent_id,
                wilayah_id: props.wilayah_id,
            })

            console.log(
                '[filter-sales] FETCH',
                params,
            )

            state.loading = true

            try {
                const { data } = await apiClient.get(
                    state.endpoint,
                    {
                        params,
                    },
                )

                state.data = Array.isArray(data)
                    ? data.sort((a, b) =>
                        a.fullname.toLowerCase() >
                        b.fullname.toLowerCase()
                            ? 1
                            : -1,
                    )
                    : []
            } catch (error) {
                console.error(
                    'Gagal mengambil sales:',
                    error,
                )

                state.data = []
            } finally {
                state.loading = false
            }
        }

        watch(
            () => [
                props.role_id,
                props.wilayah_id,
                props.parent_id,
            ],
            (newValue, oldValue) => {
                console.log(
                    '[filter-sales] FILTER CHANGED',
                    {
                        oldValue,
                        newValue,
                        role_id: props.role_id,
                        wilayah_id: props.wilayah_id,
                        parent_id: props.parent_id,
                        multiple: props.multiple,
                    },
                )

                fetchData()
            },
            {
                immediate: true,
                deep: true,
            },
        )

        const onSearch = debounce(value => {
            state.params.q = value
            fetchData()
        }, 500)

        const highlight = value => {
            return value.replace(
                new RegExp(state.params.q, 'gi'),
                match => {
                    return `<span style="background-color: yellow;">${match}</span>`
                },
            )
        }

        const dropdownVisibleChange = value => {
            if (value && state.params.q !== '') {
                state.params.q = ''
                fetchData()
            }
        }

        return {
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
            dropdownVisibleChange,
        }
    },
}
</script>

<style></style>
